class FooterSection extends HTMLElement {
    constructor() {
        super();
        this.menuLists = [];
        this.menuHeader = [];
        this.mediaQuery = null;

        this.handleMenuHeaderClick = this.handleMenuHeaderClick.bind(this);
    }

    connectedCallback() {
        this.menuLists = this.querySelectorAll('.footer-block--menu .footer-block__details-content');
        this.menuHeader = this.querySelectorAll('.footer-block--menu .footer-block__heading');

        this.mediaQuery = window.matchMedia('(max-width: 749px)');

        this.mediaQuery.addEventListener('change', this.handleMediaQueryChange.bind(this));

        this.handleMediaQueryChange(this.mediaQuery);
    }

    handleMediaQueryChange(mediaQueryList) {
        if (mediaQueryList.matches) {
            this.updateMenuList(false);

            this.menuHeader.forEach(item => item.addEventListener('click', this.handleMenuHeaderClick));
        } else {
            this.updateMenuList(true);
            this.removeActiveClassFromHeaders();
            this.removeClickListenerFromHeaders();
        }
    }

    handleMenuHeaderClick(event) {
        let content = event.target.nextElementSibling;

        if (content && content.classList.contains('footer-block__details-content')) {
            $(content).slideToggle();
            $(event.target).toggleClass('active');
        }
    }

    updateMenuList(status) {
        this.menuLists.forEach(item => {
            item.style.display = status ? 'block' : 'none';
        });
    }

    removeActiveClassFromHeaders() {
        this.menuHeader.forEach(item => item.classList.remove('active'));
    }

    removeClickListenerFromHeaders() {
        this.menuHeader.forEach(item => item.removeEventListener('click', this.handleMenuHeaderClick));
    }

    disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.handleMediaQueryChange.bind(this));

        this.removeClickListenerFromHeaders();
    }
}

customElements.define('footer-section', FooterSection);
